// Centralized per-route SEO metadata, consumed by <Seo /> on every page.
// Backed by routes.json so the same data can be read by scripts/generate-sitemap.js
// without needing a build step.

import routes from "./routes.json";

export const BASE_URL = "https://www.bumilogistics.id";
export const OG_IMAGE = `${BASE_URL}/og-image.jpg`;

export const getRouteMeta = (path) =>
  routes.find((r) => r.path === path) || routes[0];

export default routes;
